import { Radio } from 'antd';
import AntRadiobox from './styles/radiobox.style';

export const IsoRadioBox = AntRadiobox(Radio);
export const IsoRadioGroup = AntRadiobox(Radio.Group);
export const IsoRadioButton = AntRadiobox(Radio.Button);
